/** Strings owned by `src/features/departments/` — WP-12's Departments
 * section in the normal app (§ Bedrijfscontext, § Zichtbaarheid). */
export const departments = {
  page: {
    title: 'Departments',
    leadPersonal: 'Departments you are a member of.',
    leadCompany: 'Departments in {{company}}.',
  },
  list: {
    cardTitle: 'Departments',
    name: 'Name',
    company: 'Company',
    statistics: 'Statistics',
    collectiveConsent: 'Collective consent',
    inForce: 'in force',
    none: '—',
    unattached: 'unattached',
    empty: 'No departments here yet.',
    newDepartment: 'New department',
  },
  compare: {
    cardTitle: 'How departments compare',
    pageTitle: 'How departments compare',
    lead: 'Comparing the departments whose statistics you may see.',
    empty: 'No department here has statistics you may see.',
  },
  detail: {
    thisDepartment: 'department',
    edit: 'Edit',
    setVisibility: 'Set visibility',
    collectiveConsent: 'Collective consent',
    coach: 'Coach',
    category: 'Category',
    type: 'Type',
    statistics: 'Statistics',
    notRecorded: 'not recorded',
    membersCardTitle: 'Members',
    statsCardTitle: 'Statistics',
    settingsCardTitle: 'Settings',
    addPerson: 'Add person',
    name: 'Name',
    nickname: 'Nickname',
    login: 'Login',
    yes: 'yes',
    no: 'no',
    noMembers: 'No members.',
  },
  form: {
    newTitle: 'New department',
    newLead:
      'Every new department starts aggregate-only — the privacy-preserving state is the one you get by doing nothing.',
    name: 'Name',
    category: 'Category',
    type: 'Type',
    cancel: 'Cancel',
    create: 'Create department',
    editTitle: 'Edit department',
    save: 'Save',
    deleteCardTitle: 'Delete',
    deleteButton: 'Delete this department',
    deleteConfirm: 'Delete {{name}} permanently?',
    deleteKeep: 'Keep it',
    deleteYes: 'Yes, delete',
    visibilityTitle: 'Statistics visibility',
    visibilityLead:
      'individual does not by itself expose anyone: it permits individual access where a consent basis covers the member. Flipping to individual without a collective record creates a pending consent row for every current member.',
    visibilityAggregate: 'aggregate — group numbers only',
    visibilityIndividual: 'individual — per-member access where consent covers it',
    collectiveConsentTitle: 'Collective consent basis',
    collectiveConsentLead:
      'While a collective record is in force it covers every member of {{name}}, whatever their personal answer says. Members’ own rows are kept and take effect again when it is revoked.',
    collectiveConsentNote: 'Off-platform agreement (identify it precisely)',
    collectiveConsentRecord: 'Record collective basis',
    revokeCardTitle: 'Revoke',
    revokeButton: 'Revoke the collective basis',
  },
} as const;
